module.exports = __webpack_public_path__ + "img/ic-langlopen.bc1c8ed6.svg";